import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import { Trans } from "react-i18next";

const PrereqTooltipContent = ({ prereqName }) => {
  let prerequisites = prereqName.join(",\n");

  return (
    <Typography variant="body2" color="textPrimary">
      <Trans
        i18nKey="components.tooltip.prereqTooltipContent.prereqMessage"
        values={{ prerequisites }}
      >
        You must complete
        <Box component="span" fontWeight="bold">
          {prerequisites}
        </Box>
        before starting this course.
      </Trans>
    </Typography>
  );
};

export default PrereqTooltipContent;

PrereqTooltipContent.propTypes = {
  prereqName: PropTypes.arrayOf(PropTypes.string)
};
